import { render, staticRenderFns } from "./RegisterIndividual.vue?vue&type=template&id=9c443a36&scoped=true"
import script from "./RegisterIndividual.vue?vue&type=script&lang=js"
export * from "./RegisterIndividual.vue?vue&type=script&lang=js"
import style0 from "./RegisterIndividual.vue?vue&type=style&index=0&id=9c443a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c443a36",
  null
  
)

export default component.exports